module.exports = __webpack_public_path__ + "distribution/img/none.16c6722a.png";